import React, { useCallback, useEffect, useState } from 'react';

import { Container } from './styles';

import api from '~/services/api';
import InfiniteScroll from '~/components/InfiniteScroll';
import TicketsGroup from '../TicketsGroup';
import Loading from '~/components/Loading';

interface ITicket {
  user_id: number;
  event_id: number;
  event: string;
  slug: string;
  start_date: string;
  end_date: string;
  identifier: string;
  location: string;
  event_tab: string;
  total_quantity: string;
  available_quantity: string;
  used_quantity: string;
  canceled_quantity: string;
}

interface ITicketResponse {
  data: ITicket[];
  from: number;
  to: number;
  total: number;
  pages: number;
}

interface INextsProps {
  externalTickets?: ITicket[];
}

const Nexts: React.FC<INextsProps> = ({ externalTickets }) => {
  const [tickets, setTickets] = useState<ITicket[]>([]);

  const displayTickets = externalTickets ?? tickets;
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loadingMore, setLoadingMore] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLoadTickets = useCallback(async (pageData) => {
    try {
      setLoading(true);
      const response = await api.get<ITicketResponse>('events/tickets', {
        params: {
          page: pageData,
          status: 'income',
        },
      });

      if (pageData === 1) {
        setTickets(response.data.data);
      } else {
        setTickets((state) => [...state, ...response.data.data]);
      }
      setTotalPages(response.data.pages);
    } catch (error) {
      // console.log(error);
    } finally {
      setLoadingMore(false);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    handleLoadTickets(1);
  }, [handleLoadTickets]);

  const handleLoad = useCallback(async () => {
    if (!loadingMore) {
      setLoadingMore(true);
      if (page < totalPages) {
        await handleLoadTickets(page + 1);
        setPage(page + 1);
      } else {
        setLoadingMore(false);
      }
    }
  }, [handleLoadTickets, loadingMore, page, totalPages]);

  return (
    <>
      <Container>
        <InfiniteScroll onInfiniteLoad={handleLoad} className="infinite-scroll">
          {displayTickets.map((ticket) => (
            <TicketsGroup ticket={ticket} />
          ))}
        </InfiniteScroll>
      </Container>
      <Loading active={loading} text="Carregando..." />
    </>
  );
};

export default Nexts;
